<template>
  <b-row>
    <b-col class="mx-5">
      <h1>Licencias</h1>
      <LmLicenses isAdmin :user="$route.params.id" />
    </b-col>
  </b-row>
</template>

<script>
import LmLicenses from '@/components/LmLicenses.vue'

export default {
  data () {
    return {
      user: null
    }
  },
  components: {
    LmLicenses
  }
}
</script>
